<template>
  <el-dialog
    :title="title"
    :visible.sync="dialogVisible"
    :close-on-click-modal="false"
    :show-close="true"
    :lock-scroll="true"
    :modal-append-to-body="true"
    :append-to-body="true"
    v-if="dialogVisible"
    @close="closeDialog()"
    width="500px"
    class="edit-patient"
  >
    <div>
      <div class="step-wrapper">
        <el-steps
          :active="activeCard"
          finish-status="success"
          simple
          :class="selectedPatient ? 'clickable-step' : ''"
        >
          <el-step
            :title="
              $t('text.select_a_patient', {
                patient: $firstLetterCapitalize($store.state.locale.patient)
              })
            "
            icon="el-icon-user"
            @click.native="goTab(0)"
            :class="activeCard === 0 ? 'active-step' : ''"
          ></el-step>
          <el-step
            :title="secondCardTitle"
            icon="el-icon-help"
            @click.native="goTab(1)"
            :class="activeCard === 1 ? 'active-step' : ''"
            :status="selectedPatient ? 'process' : ''"
          ></el-step>
        </el-steps>
      </div>
      <SelectPatient
        ref="selectPatient"
        @patientChange="patientChange"
        v-show="activeCard === 0"
      />
      <div v-show="activeCard === 1">
        <PatientProductsSection
          ref="patientProductsSection"
          v-show="actionType === patientQuickActions.changeProduct"
        />
        <PatientDeviceSection
          :actionType="actionType"
          ref="patientDeviceSection"
          v-show="actionType !== patientQuickActions.changeProduct"
        />
      </div>
    </div>
    <div slot="footer" class="dialog-footer">
      <el-button
        type="text"
        class="back-btn"
        v-if="activeCard !== 0"
        @click="back()"
        ><i class="el-icon-arrow-left mr-5"></i
        >{{ $t('text.back').toUpperCase() }}</el-button
      >
      <el-button
        class="common-btn min-w-80"
        @click="submit()"
        :loading="saveLoading"
        v-if="activeCard !== 0"
        >{{ $t('text.update').toUpperCase() }}</el-button
      >
      <el-button class="common-btn min-w-80" @click="next()" v-else>{{
        $t('text.continue').toUpperCase()
      }}</el-button>
    </div>
  </el-dialog>
</template>

<script>
import { patientQuickActions } from '@/const'
import PatientProductsSection from '@/components/manage/patients/editPatient/PatientProductsSection.vue'
import PatientDeviceSection from '@/components/manage/patients/editPatient/PatientDeviceSection.vue'
import SelectPatient from '@/components/patients/quickActions/SelectPatient.vue'
import swal from 'sweetalert'
export default {
  data() {
    return {
      patientQuickActions,
      title: '',
      actionType: '',
      dialogVisible: false,
      activeCard: 0,
      saveLoading: false,
      selectedPatient: ''
    }
  },
  props: {
    shouldRedirectDashboard: {
      type: Boolean,
      require: false,
      default: true
    }
  },
  components: {
    PatientProductsSection,
    PatientDeviceSection,
    SelectPatient
  },
  computed: {
    secondCardTitle() {
      let title = null
      switch (this.actionType) {
        case patientQuickActions.changeProduct:
          title = this.$t('text.assign_products')
          break
        case patientQuickActions.assignPod:
          title = this.$t('text.assign_pod')
          break
        case patientQuickActions.assignNode:
          title = this.$t('text.assign_node')
          break
      }
      return title
    }
  },
  methods: {
    patientChange(e) {
      this.selectedPatient = e
      if (!e) return
      this.$refs.patientProductsSection.form = this.selectedPatient
      this.$refs.patientDeviceSection.form = this.selectedPatient
      this.$refs.patientDeviceSection.prevPod = this.selectedPatient.AllocatedPod
      if (this.selectedPatient) {
        this.activeCard = 1
      }
    },
    goTab(index) {
      if (!this.selectedPatient) return false
      this.activeCard = index
    },
    next() {
      this.$refs.selectPatient.$refs.form.validate(valid => {
        if (valid) {
          this.activeCard++
        }
      })
    },
    back() {
      this.activeCard--
    },
    openDialog(title, actionType) {
      this.dialogVisible = true
      this.title = title
      this.actionType = actionType
    },
    closeDialog() {
      this.$refs.selectPatient.$refs.form.resetFields()
      this.$refs.selectPatient.form = {
        selectedPatient: ''
      }
      this.$refs.patientProductsSection.$refs.form.resetFields()
      this.$refs.patientDeviceSection.$refs.form.resetFields()
      this.title = ''
      this.actionType = ''
      this.activeCard = 0
      this.dialogVisible = false
    },
    submit() {
      if (this.actionType === patientQuickActions.changeProduct) {
        this.$refs.patientProductsSection.$refs.form.validate(valid => {
          // User should be able to use just day product or night product. Both are not necessary
          let dayProduct = this.$refs.patientProductsSection.form.DayProductId
          let nightProduct = this.$refs.patientProductsSection.form
            .NightProductId

          let dayProductValid = dayProduct && dayProduct > 0
          let nightProductValid = nightProduct && nightProduct > 0
          let productValid = valid && (dayProductValid || nightProductValid)
          if (!dayProductValid && !nightProductValid) {
            swal({
              icon: 'warning',
              title: 'Warning',
              text: this.$t('text.please_select_one_product')
            })
          }
          if (productValid) {
            this.save()
          }
        })
      } else {
        this.$refs.patientDeviceSection.$refs.form.validate(valid => {
          if (valid) {
            this.save()
          }
        })
      }
    },
    save() {
      let patient = {
        ...this.$refs.patientDeviceSection.form,
        ...this.$refs.patientProductsSection.form,
        ...this.selectedPatient
      }
      this.saveLoading = true
      this.$store
        .dispatch('patient/savePatient', patient)
        .then(response => {
          this.saveLoading = false
          if (response.data.success) {
            this.closeDialog()
            if (this.shouldRedirectDashboard) {
              this.$router.push({
                path: '/care-plus-dashboard',
                query: { hightLightPatientId: response.data.data.PatientId }
              })
            }
            this.$emit('success')
          }
        })
        .catch(() => {
          this.saveLoading = false
        })
    }
  }
}
</script>
